import React, { ChangeEvent, FunctionComponent, useEffect, useRef, useState } from "react";

import { bemClassNames } from "@multiweb/reactUtils";

type AutoTextAreaProps = {
    readonly readOnly?: boolean;
    readonly textValue: string;
    readonly onChange: (e: ChangeEvent<HTMLTextAreaElement>) => void;
};

const classNames = bemClassNames("auto-text-area-component");
const autoTextAreaClassName = classNames();

export const AutoTextArea: FunctionComponent<AutoTextAreaProps> = ({ readOnly, textValue, onChange }) => {
    const textAreaRef = useRef<HTMLTextAreaElement>(null);
    const [messageText, setMessageText] = useState(textValue);
    const [textAreaHeight, setTextAreaHeight] = useState("auto");

    useEffect(() => {
        setTextAreaHeight(`${textAreaRef.current?.scrollHeight}px`);
    }, [messageText]);

    const onChangeHandler = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setTextAreaHeight("auto");
        setMessageText(event.target.value);

        if (onChange) {
            onChange(event);
        }
    };

    return (
        <textarea
            className={autoTextAreaClassName}
            ref={textAreaRef}
            style={{ height: textAreaHeight }}
            rows={1}
            onChange={onChangeHandler}
            readOnly={readOnly}
            value={messageText} />
    );
};
